import React from "react"
import { ArrowLeftThinIcon, RestartIcon, H6 } from "AtomicComponents"

const BuildCompactNav = props => (
  <div style={styles.base}>
    <div onClick={props.back} style={styles.icon}>
      {
        props.active !== 1 &&
        <ArrowLeftThinIcon style={styles.icon} />
      }
      </div>
    <H6 withDetails>{props.title}</H6>
    <div onClick={props.reload} style={styles.icon}>
      {
        props.active !== 1 &&
        <RestartIcon style={styles.icon} />
      }
    </div>
  </div>
)

const styles = {
  base: {
    display: "flex",
    width: "100%",
    overflow: "hidden",
    background: "#fff",
    justifyContent: "space-between",
    borderBottom: "1px solid #e5e5e5",
    padding: "1em",
    boxSizing: "border-box",
    position: "relative",
    zIndex: "5"
  },
  icon: {
    width: "22px",
    height: "22px",
    display: "block",
    color: "#999999",
    cursor: "pointer"
  }
}

export default BuildCompactNav



// WEBPACK FOOTER //
// ./src/containers/build/build-compact-nav.jsx